module.exports = __webpack_public_path__ + "img/sc.b174a49f.svg";